import { useMemo } from 'react';
import { bi } from '../../../../services/loggers/bi';
import { extractCommonBiFieldsFromItems } from '../../../bi';
import { ClickOrigin, PreviewTarget } from './useTrackPreviewActions.types';
import { MediaManagerSDKAnyItem } from '../../../media-manager-sdk';
import { useFileType } from '../useFileType';
import { mediaManagerPreviewActions } from '@wix/bi-logger-media-manager-g6/v2';
import { BIPageName } from '../../../../constants/Bi';

export const useTrackPreviewActions = () => {
  const fileType = useFileType();

  return useMemo(
    () => ({
      trackPreviewActionsContextMenuClicked: (items: MediaManagerSDKAnyItem[]) =>
        bi.logger().report(
          mediaManagerPreviewActions({
            ...extractCommonBiFieldsFromItems(items, { fileType }),
            target: PreviewTarget.Opened,
            clickOrigin: ClickOrigin.Actions,
            pageName: BIPageName.MediaManager,
          }),
        ),
      trackPreviewActionsExpandButtonClicked: (clickOrigin: ClickOrigin) =>
        bi.logger().report(
          mediaManagerPreviewActions({
            target: PreviewTarget.Opened,
            pageName: BIPageName.MediaManager,
            clickOrigin,
          }),
        ),
      trackPreviewActionsPreviewBottomNavigationClicked: (item) =>
        bi.logger().report(
          mediaManagerPreviewActions({
            target: PreviewTarget.Opened,
            clickOrigin: ClickOrigin.PreviewBottomNavigation,
            fileId: item.id,
            pageName: BIPageName.MediaManager,
            ...extractCommonBiFieldsFromItems(item, { fileType }),
          }),
        ),
      trackPreviewActions: (params, item) =>
        bi.logger().report(
          mediaManagerPreviewActions({
            ...extractCommonBiFieldsFromItems(item, { fileType }),
            pageName: BIPageName.MediaManager,
            ...params,
          }),
        ),
    }),
    [fileType],
  );
};
